import { css } from 'styled-components';
import { Text02 } from './colors';

export const BodyLong01 = css`
  font-size: var(--font-size-base);
  line-height: var(--line-height-body-long-01);
`;

export const Code01 = css`
  font-family: var(--code-font-family);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-code-01);
`;

export const BodyShort01 = css`
  font-size: var(--font-size-base);
  line-height: var(--line-height-body-short-01);
`;

export const BodyShort02 = css`
  font-size: var(--font-size-lg);
  line-height: var(--line-height-body-short-02);
`;

export const Caption01 = css`
  font-size: var(--font-size-sm);
  line-height: var(--line-height-caption-01);
  font-weight: 400;
`;
export const ProductiveHeading08 = css`
  font-size: var(--font-size-sm);
  font-weight: var(--heading-8-weight);
  line-height: var(--heading-8-line-height);
`;

export const ProductiveHeading07 = css`
  font-size: var(--font-size-base);
  font-weight: var(--heading-7-weight);
  line-height: var(--heading-7-line-height);
`;

export const ProductiveHeading06 = css`
  font-size: var(--heading-6-size);
  font-weight: var(--heading-6-weight);
  line-height: var(--heading-6-line-height);
`;

export const ProductiveHeading05 = css`
  font-size: var(--heading-5-size);
  font-weight: var(--font-weight-semi-bold);
  line-height: var(--heading-5-line-height);
`;

export const ProductiveHeading04 = css`
  font-size: var(--heading-4-size);
  font-weight: var(--heading-4-weight);
  line-height: var(--heading-4-line-height);
`;

export const ProductiveHeading03 = css`
  font-size: var(--heading-3-size);
  font-weight: var(--heading-3-weight);
  line-height: var(--heading-3-line-height);
`;

export const ProductiveHeading02 = css`
  font-size: var(--heading-2-size);
  font-weight: var(--heading-2-weight);
  line-height: var(--heading-2-line-height);
`;

export const ProductiveHeading01 = css`
  font-size: var(--heading-1-size);
  font-weight: var(--heading-1-weight);
  line-height: var(--heading-1-line-height);
`;

export const ProductiveCompact01 = css`
  font-size: var(--font-size-base);
  font-weight: var(--heading-6-weight);
  line-height: var(--heading-7-line-height);
`;

export const ColFlexBox01 = css`
  display: flex;
  font-weight: var(--heading-4-weight);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-06);
`;

export const HelperText01 = Caption01;

export const Label01 = css`
  font-size: var(--font-size-sm);
  line-height: var(--line-height-caption-01);
  font-weight: 400;

  :root[data-new-theme-enabled='true'] & {
    font-weight: var(--font-weight-bold);
  }
`;

export const Label = css`
  ${Label01};
  ${Text02};
`;

export const HelperText = css`
  ${HelperText01};
  ${Text02};
`;

export const PlaceholderText = css`
  font-style: italic;
  color: var(--cp-gray-100);
  font-weight: var(--heading-4-weight);
`;
